var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 76,
    viewBox: "0 0 96 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_107_2303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66.6682,
    cy: 44.6683,
    r: 24,
    transform: "rotate(7.4756 66.6682 44.6683)",
    fill: "#8CEEEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.1697 53.3653C69.7283 53.4306 70.2764 53.4527 70.8137 53.4316C71.351 53.4106 71.8673 53.3451 72.3626 53.2352L72.4498 56.3917C71.8328 56.4664 71.1935 56.507 70.532 56.5135C69.8705 56.5201 69.2035 56.4841 68.531 56.4054C67.2585 56.2566 66.1111 55.9337 65.089 55.4367C64.0772 54.9408 63.2263 54.2802 62.5362 53.4549C61.8474 52.6193 61.3498 51.6277 61.0435 50.4802C60.7487 49.3235 60.6872 48.0106 60.859 46.5415L61.4741 41.2805C61.6507 39.7699 62.0171 38.4756 62.5731 37.3974C63.1407 36.3102 63.8624 35.4297 64.7383 34.756C65.6244 34.0835 66.6279 33.6188 67.7487 33.3618C68.8798 33.106 70.1023 33.0549 71.4163 33.2085C72.0577 33.2835 72.6731 33.4027 73.2623 33.566C73.863 33.7201 74.4601 33.9053 75.0536 34.1215L74.2388 37.1883C73.8017 36.9798 73.3196 36.7976 72.7925 36.6416C72.2758 36.4868 71.7484 36.3779 71.2104 36.315C70.4137 36.2219 69.6807 36.2568 69.0115 36.4197C68.3525 36.5839 67.7722 36.8831 67.2704 37.3174C66.7699 37.7413 66.3565 38.317 66.0302 39.0444C65.7143 39.7731 65.4953 40.6599 65.3731 41.7049L64.7543 46.9969C64.6334 48.0316 64.6489 48.9301 64.801 49.6925C64.9646 50.4457 65.2417 51.0812 65.6321 51.5988C66.0238 52.106 66.5173 52.5046 67.1127 52.7944C67.7184 53.0855 68.404 53.2758 69.1697 53.3653ZM71.0088 41.6716L70.7602 43.7978L58.6242 42.3788L58.8728 40.2527L71.0088 41.6716ZM70.5225 45.8308L70.2739 47.9569L58.1379 46.538L58.3865 44.4118L70.5225 45.8308Z",
    fill: "#262626"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_107_2303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.7611,
    cy: 30.7611,
    r: 24,
    transform: "rotate(-20 30.7611 30.7611)",
    fill: "#FDE759"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3426 16.1137L28.0021 20.4809L25.7528 21.3357L24.0932 16.9685L26.3426 16.1137ZM35.1287 40.0708L36.6161 43.9852L34.3814 44.8344L32.8939 40.92L35.1287 40.0708ZM35.5414 34.5149C35.3268 33.9502 35.0231 33.5028 34.6303 33.1729C34.2435 32.8296 33.7274 32.5856 33.0818 32.4409C32.4325 32.2865 31.6172 32.223 30.6359 32.2504C29.223 32.2859 27.9455 32.2086 26.8035 32.0185C25.6676 31.815 24.688 31.4072 23.8648 30.7951C23.0476 30.1696 22.4078 29.2482 21.9453 28.031C21.4902 26.8334 21.3687 25.6927 21.581 24.6092C21.803 23.5219 22.3151 22.5528 23.1173 21.702C23.9194 20.8511 24.9778 20.1759 26.2923 19.6764C27.305 19.2916 28.2728 19.0966 29.1957 19.0913C30.1283 19.0823 30.9929 19.2608 31.7894 19.6268C32.5859 19.9927 33.2979 20.5467 33.9254 21.2889C34.5589 22.0177 35.0847 22.9322 35.5029 24.0325L31.9974 25.3646C31.7606 24.7414 31.4767 24.2141 31.1456 23.7827C30.8206 23.3379 30.457 22.9969 30.0548 22.7597C29.649 22.5128 29.2161 22.3708 28.7563 22.3338C28.3063 22.2931 27.8378 22.3653 27.351 22.5503C26.6596 22.813 26.1399 23.1609 25.7919 23.594C25.4402 24.0174 25.2423 24.4938 25.1983 25.0231C25.1641 25.5487 25.2561 26.0988 25.4744 26.6733C25.6853 27.2283 25.9774 27.6745 26.3507 28.0118C26.7241 28.3491 27.2335 28.5901 27.8791 28.7348C28.5307 28.866 29.379 28.9281 30.4238 28.9211C31.8501 28.8917 33.1264 28.9806 34.2526 29.1878C35.3848 29.3816 36.3528 29.7882 37.1565 30.4077C37.9663 31.0138 38.6024 31.9254 39.065 33.1426C39.5423 34.3987 39.6553 35.5759 39.4041 36.6743C39.1626 37.769 38.6079 38.7431 37.7399 39.5967C36.878 40.4368 35.7605 41.1177 34.3876 41.6394C33.5209 41.9688 32.6166 42.1843 31.6746 42.2859C30.7387 42.3741 29.8251 42.2867 28.934 42.0236C28.0428 41.7605 27.2281 41.2733 26.4898 40.5621C25.7478 39.8412 25.1363 38.8478 24.6553 37.5819L28.1899 36.2387C28.4785 36.9982 28.8213 37.5923 29.2182 38.021C29.6151 38.4496 30.0443 38.7434 30.5059 38.9023C30.9674 39.0612 31.4365 39.1225 31.913 39.0863C32.3993 39.0464 32.8615 38.9432 33.2997 38.7767C34.03 38.4992 34.5972 38.1443 35.0013 37.7122C35.4114 37.2666 35.658 36.7718 35.7409 36.2276C35.8299 35.6701 35.7634 35.0992 35.5414 34.5149Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_107_2303",
    x: 34.7497,
    y: 14.7498,
    width: 63.837,
    height: 63.837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_2303"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_2303",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_107_2303",
    x: -5,
    y: -2.99997,
    width: 71.5222,
    height: 71.5222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_2303"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_2303",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.c50045ee73f45bcef57a8e1f9b80e60d.svg";
export { ForwardRef as ReactComponent };